module.exports = __webpack_public_path__ + "media/5.6fed7f0e.mp3";